import {
  Building2,
  Shield,
  Users,
  Scale,
  Briefcase,
  Landmark,
  Zap,
  Calculator,
  FileCheck,
  FileText,
} from 'lucide-react';

export const practiceAreas = [
  {
    icon: Building2,
    title: 'Corporate Law',
    description:
      'We advise companies on governance, restructuring, mergers and acquisitions, due diligence, and risk management to ensure strong and compliant business operations.',
    details:
      'Our Law office in relation to corporate Law provides legal services in the following areas: - Implementation of corporate governance principles; Restructuring of companies; Mergers & Acquisitions, transaction documentation included; Legal advisor for Mergers & Acquisitions transactions; Due diligence according to the scope of business; Legal support for risk management.',
  },
  {
    icon: Scale,
    title: 'Competition Law',
    description:
      'We help businesses comply with competition rules, prevent unfair trade practices, and represent clients before regulatory authorities in competition and state aid matters.',
    details:
      'Competition Law has an impact on each business entity. In order to provide complex consultancy this branch is an integral part of our services: - Legal advisory in unfair trade; Appraisal of possible impacts of competition Law on activities of our clients; Legal advisory in the area of infrastructure; Representation before the Competition Commission; Appraisal of the negative aspects of the abuse of the dominant position; Legal advisory in state aid Law.',
  },
  {
    icon: FileText,
    title: 'Business Law and Property Law',
    description:
      'We support businesses by structuring contracts, protecting assets, managing property matters, and safeguarding their legal and financial interests.',
    details:
      'We render our services to Kosovan and foreign clients, whereby we support them and secure their due performance of business activities as well as the protection of their rights and rightful interests. In the area of Business Law and Property Law, we mainly perform the following: - Preparation and analysis of contracts and contractual relationships; Preparation of sample agreements and general business terms; Protection of assets; Legal appraisal of property structure and identification of risky areas; Due diligence of contractual relations; Legal advisory for creditors during execution of their rights.',
  },
  {
    icon: Calculator,
    title: 'Tax Law',
    description:
      'We provide strategic tax advice for transactions and ensure compliance with direct and indirect tax regulations, including representation in tax disputes.',
    details:
      'We provide top quality advice on tax Law in different types of transactions, such as mergers and acquisition, asset transfer transactions, real estate projects, cross-border and international trade transactions. In addition to this, we also provide general advisory services on compliance with Laws on direct taxes, such as corporate income tax, as well as indirect taxes, such as VAT. We also deal with tax disputes involving the Tax Administration and Customs.',
  },
  {
    icon: Briefcase,
    title: 'Labor Law',
    description:
      'We guide employers through employment matters, regulatory compliance, internal policies, disciplinary decisions, and representation in labor disputes.',
    details:
      'In the area of Labor Law, we provide the following: - Legal advice on a case-to-case basis; Reviewing and drafting internal acts and rules; Preparation of and providing comments on all types of employment contracts; Advice on employment decisions and disciplinary measures; Representation in labor disputes before the Labor Inspectorate and courts.',
  },
  {
    icon: FileCheck,
    title: 'Public Procurement',
    description:
      'We assist clients in meeting participation requirements, preparing proposals, and representing them in procurement objection procedures.',
    details:
      'Our services in Public procurement can be used as follows: - Legal appraisal of conditions for participation in public procurement and criteria for appraisal; Legal advisory during the preparation of a proposal; Representation of a participant in an objection procedure.',
  },
  {
    icon: Zap,
    title: 'Energy Law',
    description:
      'We advise on regulatory and market frameworks governing electricity generation, distribution, renewable energy, and energy market operations.',
    details:
      'We have experience in the legislative framework and institutional set-up governing the enforcement of the competition policy and Law applying to the Kosovo electricity sector. We advise on the rules governing generation capacity, renewable energy (wind, solar, biomass), transmission and distribution separation, access charges, retail competition, and the establishment and functioning of wholesale electricity markets.',
  },
  {
    icon: Users,
    title: 'Family Law',
    description:
      'We provide strategic and compassionate legal support in divorce, custody, support, property division, and other family-related matters.',
    details:
      'Family Law directly affects individuals and families at some of the most important moments of their lives. Our services include: - Legal advisory in divorce and legal separation proceedings; Assistance in child custody and visitation matters; Advisory and representation in child and spousal support cases; Drafting and review of prenuptial and postnuptial agreements; Legal support in adoption and guardianship procedures; Representation in domestic violence and protection order proceedings; Legal advisory on property division.',
  },
  {
    icon: Landmark,
    title: 'Litigation',
    description:
      'We represent clients in disputes by developing strategic, cost-effective solutions and pursuing the best possible outcome through negotiation or court proceedings.',
    details:
      'We take a constructive approach and are always aware of the costs of pursuing or defending an action through the courts. We seek to avoid court proceedings if possible and advise on all forms of alternative dispute resolution. If litigation is unavoidable, we employ sophisticated strategic planning, technical expertise, and cost-efficient case management to ensure that your rights are protected and enforced as effectively as possible.',
  },
];
